function MaskIcon({ width = '21', height = '20', fill = '#615A5A' }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <mask
          id="mask0_10938_197519"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width={width}
          height={height}
        >
          <rect x="0.910645" width="19.7054" height="19.7054" fill="#C4C4C4" />
        </mask>
        <g mask="url(#mask0_10938_197519)">
          <mask
            id="mask1_10938_197519"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width={width}
            height={height}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.296 3.94109C12.296 6.11744 14.0607 7.88217 16.2371 7.88217C18.4134 7.88217 20.1782 6.11744 20.1782 3.94109C20.1782 1.76473 18.4134 0 16.2371 0C14.0607 0 12.296 1.76473 12.296 3.94109ZM17.6803 2.5592L18.2896 3.16913L15.8267 5.67829L14.3485 4.24511L14.9584 3.63393L15.8267 4.45843L17.6803 2.5592ZM0.910645 0V19.7054H9.83438C12.6044 19.7054 18.4266 13.7744 18.4266 11.812V8.62097C17.8811 8.83429 17.2905 8.96691 16.675 9.0107V11.1201C16.675 14.4919 11.4202 13.137 11.4202 13.137C11.4202 13.137 12.7495 18.0633 9.10997 18.0633H2.66224V1.64212H10.9823C11.2557 1.02656 11.6504 0.47293 12.1346 0H0.910645ZM5.28963 5.25478V6.13058H10.9823C10.8647 5.85032 10.7746 5.5563 10.7033 5.25478H5.28963ZM5.28963 7.88217V8.75797H13.2131C12.819 8.50962 12.4574 8.21685 12.1346 7.88217H5.28963ZM5.28963 11.3854H14.0476V10.5096H5.28963V11.3854Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_10938_197519)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-2.21606 22.8332H23.3071V-3.12793H-2.21606V22.8332Z"
              fill={fill}
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default MaskIcon;
